import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const plans = [
  {
    id: 1,
    title: "PCOD Assessment",
    subtitle: "Get a complete PCOD Diagnosis from Expert Doctors",
    price: { original: "₹1499", discount: "₹1299/-" },
    features: [
      "15-min Doctor Consultation",
      "Detailed PCOD assessment",
      "Root cause analysis",
      "1 Follow-up consultation",
      "Medicine at Doorstep (Extra charges applicable)",
      "Diagnostic Test Prescription",
    ],
    note: "Ideal for those confused or anxious about their symptoms. Expert doctors will clarify all your PCOD concerns.",
    department: "Gynecology",
  },
  {
    id: 2,
    title: "3-Month Nutrition Plan",
    subtitle: "Manage weight, improve gut health, and balance hormones",
    price: { original: "₹2499", discount: "₹1999/Month" },
    features: [
      "Weekly Dietitian Consultation",
      "Custom Diet Plan",
      "Free Follow-up consultations under 15 Days",
      "Unlimited chat support",
      "Weekly Care Manager follow-ups",
      "Macro/Micronutrient tracking",
      "Habit Coaching & Recipe Booklet",
    ],
    note: "Perfect for anyone looking to manage weight and adopt a science-backed diet plan for PCOD management.",
    department: "Nutrition",
  },
  {
    id: 3,
    title: "3-Month PCOD Pro Plan",
    subtitle: "Get complete care and guidance for PCOD management",
    price: { original: "₹4999", discount: "₹3833/Month" },
    features: [
      "Detailed PCOD assessment by Expert Doctors",
      "Access to 3-Month Nutrition Program",
      "Access to 3-Month Yoga Program",
      "24/7 Care Manager Support through Chat",
      "Exclusive PCOD Community Access",
      "Diagnostic Test at Home (with extra charges)",
    ],
    note: "Designed for those aiming to manage and reverse PCOD with medical care + lifestyle modification.",
    department: "Gynecology & Nutrition",
  },
  {
    id: 4,
    title: "3-Month Yoga Plan",
    subtitle: "Get fit, flexible, and healthy naturally",
    price: { original: "₹3499", discount: "₹2999/Month" },
    features: [
      "Astanga & Fertility Yoga tailored for PCOD",
      "60 LIVE Yoga Sessions",
      "Personalized coaching",
      "Regular review & feedback",
      "Detailed PCOD assessment",
    ],
    note: "Perfect for girls looking to improve health through expert-guided yoga at home, online and convenient.",
    department: "Yoga",
  },
];

const Planes = () => {
  const navigate = useNavigate();
  return (
    <div className="py-16 bg-gradient-to-b from-pink-50 to-pink-100">
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-5xl font-bold text-pink-600 text-center my-16"
      >
        Our Plans
      </motion.h2>

      <div className="max-w-7xl mx-auto grid gap-16 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-4">
        {plans.map((plan) => (
          <motion.div
            key={plan.id}
            initial={{ scale: 0.9, opacity: 0, y: 50 }}
            whileInView={{ scale: 1, opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-3xl shadow-lg flex flex-col justify-between p-6 border border-pink-100 hover:shadow-2xl relative my-4"
          >
            <div className="absolute -top-2 right-4 bg-pink-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
              {plan.department}
            </div>

            <div className="flex flex-col gap-2 mb-4">
              <h3 className="text-2xl font-bold text-[#020046">{plan.title}</h3>
              <p className="text-gray-600 text-sm">{plan.subtitle}</p>
            </div>

            <div className="mb-4 flex items-center gap-2">
              <span className="text-gray-400 line-through text-lg">
                {plan.price.original}
              </span>
              <span className="text-2xl font-bold text-pink-600">
                {plan.price.discount}
              </span>
            </div>

            <ul className="mb-4 space-y-4">
              {plan.features.map((feat, i) => (
                <li
                  key={i}
                  className="flex items-center gap-2 text-gray-700 text-sm"
                >
                  <FaCheckCircle className="text-pink-500" />
                  {feat}
                </li>
              ))}
            </ul>

            <p className="text-gray-500 text-sm mb-4">{plan.note}</p>

            <div className="relative">
              <motion.button
                onClick={() => navigate("/booking")}
                onTap={() => navigate("/booking")}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-pink-600 text-white py-2 rounded-full font-semibold transition absolute w-1/2 left-1/4 cursor-pointer"
              >
                Enroll Now
              </motion.button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Planes;
